<router-outlet />
<!-- Chargement plein écran à l'ouverture d'un dossier, écran d'erreur d'une navigation (core/navigation-etat.ts). -->
<app-navigation-etat />

<!-- #region Message bref (toast) : succès, information ou erreur -->
@if (toast.courant(); as t) {
  <div
    class="toast"
    [class.t-err]="t.ton === 'err'"
    [class.t-info]="t.ton === 'info'"
    [attr.role]="t.ton === 'err' ? 'alert' : 'status'"
  >
    <svg appIcone [name]="t.ton === 'err' ? 'alert' : t.ton === 'info' ? 'info' : 'check'" [size]="15" [weight]="2.4"></svg>{{ t.texte }}
  </div>
}
<!-- #endregion -->
